import type { Snapshot } from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { isDateValid } from '@/utils/dateTime';
import { dayjs } from '@/utils/dayjs';

export const useDateSnapshots = (
  eonSnapshots: Snapshot[],
  selectedDate: Date
) => {
  return useMemo(() => {
    return selectedDate
      ? (eonSnapshots ?? [])
          .filter((e) => {
            const date = isDateValid(e.pointInTime)
              ? e.pointInTime
              : e.createdTime;

            return dayjs.utc(date).isSame(dayjs.utc(selectedDate), 'date');
          })
          .sort((a, b) => {
            const dateA = isDateValid(a.pointInTime)
              ? a.pointInTime
              : a.createdTime;

            const dateB = isDateValid(b.pointInTime)
              ? b.pointInTime
              : b.createdTime;

            return dateB.getTime() - dateA.getTime();
          })
      : [];
  }, [selectedDate, eonSnapshots]);
};
